import store from '@/store/store'

import globalConfig from '@/config/index'

import lodash_cloneDeep from 'lodash/cloneDeep'

export default function(params, methods) {
    params = lodash_cloneDeep(params)
    if (params.uuid == null) params.uuid = store.state.api.uuid
    //params.uuid = 'a7935c69-9304-535c-824a-d2673f327468'
    params.current_url = globalConfig.localhostPage || window.location.href
    params.authGuestData = params.authGuestData || store.state.authGuestData

    if (methods === 'post') {
        return {
            data: params,
            headers: {
                jsonStringOff: true
            }
        }
    } else {
        return {
            params,
            headers: {
                jsonStringOff: true
            }
        }
    }
}
